export default {
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10
    }
  },
  methods: {
    currentPageChange(e) {
      this.page = e

      this.getContentList()

      // 滚动到顶部
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }
}